"use client";

import { HStack, StackProps } from "@chakra-ui/react";

interface PageFooterProps extends StackProps {}

export function PageFooter({ children, ...props }: PageFooterProps) {
  return (
    <HStack
      position="fixed"
      bottom="0"
      left="0"
      right="0"
      h={{ mobile: "72px", desktop: "80px" }}
      zIndex="overlay"
      backgroundColor="white"
      justifyContent="center"
      alignItems="center"
      px="4"
      spacing="2"
      pb="12px"
      // Ensure proper positioning in all browsers including iOS in-app browsers
      maxWidth="100vw"
      willChange="transform"
      // Use safe-area-inset for iOS devices with notches
      paddingBottom="max(12px, env(safe-area-inset-bottom))"
      {...props}
    >
      {children}
    </HStack>
  );
}
